import api from '@/api/axios.js'
// initial state
// shape: [{ id, quantity }]
const state = {
  baseStatus: [{
    value: '1',
    label: '有效'
  },
  {
    value: '0',
    label: '失效'
  }],
  //微信分享参数
  wxShareParams: {},
  baseSystemName: [],
  //钱小数位数
  moneyDecimal: 2,
  //库存查询条件所有零售商
  retailerList: [],
  //库存查询条件所有门店
  storeList: [],
  //库存管理的查询条件供应商
  supplierList: [],
  //库存管理的查询条件仓库
  warehouseList: [],
  //版型标识
  layoutName: "home",
  layoutTabRef: {},
  isRouterAlive: true,
  member: {
    alias: {
      pointsName: '',//积分别名
      growthName: ''//成长值别名
    }
  },
  //企业微信 会员权益信息
  memberEquity: [],
  //企业微信  可用卡券
  memberCard: [],
}

// getters
const getters = {
  getBaseStatus: (state, getters, rootState) => {
    return state.baseStatus;
  },
  getSystemName: (state, getters, rootState) => {
    return state.baseSystemName;
  },
  //库存管理的查询条件零售商
  getRetailerList: (state, getters, rootState) => {
    return state.retailerList;
  },
  //库存管理的查询条件门店
  getStoreList: (state, getters, rootState) => {
    return state.storeList;
  },
  //库存管理的查询条件供应商
  getSupplierList: (state, getters, rootState) => {
    return state.supplierList;
  },
  //库存管理的查询条件仓库
  getWarehouseList: (state, getters, rootState) => {
    return state.warehouseList;
  },
  getLayoutName: (state, getters, rootState) => {
    return state.layoutName;
  },
  getIsRouterAlive: (state, getters, rootState) => {
    return state.isRouterAlive;
  },
  getLayoutTabRef: (state, getters, rootState) => {
    return state.layoutTabRef;
  },
  //成长值
  getMemberAlias: (state, getters, rootState) => {
    return state.member.alias;
  },
  //积分
  getPointsName: (state, getters, rootState) => {
    return state.member.alias.pointsName;
  },
  //成长值
  getGrowthName: (state, getters, rootState) => {
    return state.member.alias.growthName;
  },
}

// actions
const actions = {
  getApiBaseStatus({ state, commit }, product) {
    api.post('roleManage/listRoleType', params, r => {
      const list = r.result || [];
      commit('baseStatus', r.result);
    }, null, "permission")
  },
  getBaseSystemName({ state, commit }, product) {
    let self = this;
    if (state.baseSystemName.length == 0) {
      api.post('lookUpManage/listPermissionTypeAndSys', { "classifyCode": "ihlp.som.permission.sys" }, r => {
        let list = r.result || [];
        list.filter(item => { item.value = item.itemCode; item.label = item.itemName })
        commit('setSystemName', list);
      }, null, "permission")
    }
  },
  //库存管理的查询条件零售商
  getAllRetailer({ state, commit }, product) {
    if (state.retailerList.length > 0) return false
    api.post({
      sc: "merchant",
      url: 'retailerManage/getAllRetailer',
      params: { test: 1 },
      success: r => {
        let list = r.result || [];
        commit('setRetailerList', list);
      }
    })
  },
  //库存管理的查询条件门店
  getAllStore({ state, commit }, product) {
    if (state.storeList.length > 0) return false
    api.post({
      sc: "merchant",
      url: 'channelManage/getAllChannel',
      params: { test: 1 },
      success: r => {
        let list = r.result || [];
        commit('setStoreList', list);
      }
    })
  },
  //库存管理的查询条件供应商
  getAllSupplier({ state, commit }, product) {
    if (state.supplierList.length > 0) return false
    api.post({
      sc: "merchant",
      url: 'supplierManage/getAllSupplier',
      params: null,
      success: r => {
        let list = r.result || [];
        commit('setSupplierList', list);
      }
    })
  },
  //库存管理的查询条件仓库
  getAllWarehouse({ state, commit }, product) {
    if (state.warehouseList.length > 0) return false
    api.post({
      sc: "inventory",
      url: 'warehouseManage/getAllWarehouse',
      params: { test: 1 },
      success: r => {
        let list = r.result || [];
        commit('setWarehouseList', list);
      }
    })
  },
  //积分与成长值设置
  getMemberAlias({ state, commit }, product) {
    api.post({
      sc: "permission",
      url: 'lookUpManage/listPermissionTypeAndSys',
      params: { classifyCode: "ihlp.oms.member.name" },
      success: r => {
        let list = r.result || [];
        commit('setMemberAlias', list);
      }
    })
  }
}

// mutations
const mutations = {
  setBaseStatus(state, { items }) {
    state.baseStatus = items
  },
  setSystemName(state, dataList) {
    state.baseSystemName = dataList
  },
  //库存管理的查询条件零售商
  setRetailerList(state, dataList) {
    state.retailerList = dataList
  },
  //库存管理的查询条件门店
  setStoreList(state, dataList) {
    state.storeList = dataList
  },
  //库存管理的查询条件供应商
  setSupplierList(state, dataList) {
    state.supplierList = dataList
  },
  //库存管理的查询条件仓库
  setWarehouseList(state, dataList) {
    state.warehouseList = dataList
  },
  setLayoutName(state, value) {
    state.layoutName = value
  },
  setIsRouterAlive(state, value) {
    state.isRouterAlive = value
  },
  setLayoutTabRef(state, value) {
    state.layoutTabRef = value
  },
  //积分与成长值
  setMemberAlias(state, list) {
    list.filter(item => {
      if (item.itemCode == "pointsName") {
        state.member.alias.pointsName = item.itemName
      }
      if (item.itemCode == "growthName") {
        state.member.alias.growthName = item.itemName
      }
    })
  },
  //微信分享参数
  setWxShareParams(state, data) {
    state.wxShareParams = data;
  },

  setMemberEquity(state, data) {
    state.memberEquity = data;
  },

  setMemberCard(state, data) {
    state.memberCard = data;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  mounted() {

  },
}


// WEBPACK FOOTER //
// ./src/store/modules/base.js